// Wax Project Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // ── Product image thumbnail switcher ───────────────────────
  var thumbsLegacy = document.querySelectorAll('.product-thumb');
  var mainImgLegacy = document.getElementById('MainProductImage');

  if (mainImgLegacy && thumbsLegacy.length) {
    thumbsLegacy.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbsLegacy.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        mainImgLegacy.src = thumb.src.replace('_120x', '_700x');
        mainImgLegacy.alt = thumb.alt;
      });
    });
  }

  // ── Variant selector → update URL ─────────────────────────
  var variantSelects = document.querySelectorAll('.product-option-select');
  if (variantSelects.length) {
    variantSelects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', sel.value);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  // ── Cart page qty validation ───────────────────────────────
  document.querySelectorAll('.cart-qty-input').forEach(function (input) {
    input.addEventListener('change', function () {
      if (parseInt(input.value, 10) < 0) input.value = 0;
    });
  });

  // ── Smooth scroll ──────────────────────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(anchor.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ── Mobile hamburger ───────────────────────────────────────
  var hamburger = document.getElementById('gh-hamburger');
  var mobileMenu = document.getElementById('gh-mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.toggle('is-open');
      hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      mobileMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });
  }

  // ── Cart drawer open / close ───────────────────────────────
  var cartDrawer  = document.getElementById('cart-drawer');
  var cartClose   = document.getElementById('cart-drawer-close');
  var cartOverlay = document.getElementById('cart-drawer-overlay');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
  }

  // Both desktop and mobile cart trigger buttons
  document.querySelectorAll('#cart-trigger, #cart-trigger-mobile').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
  });

  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  // ── Cart helpers ───────────────────────────────────────────
  function formatMoney(cents) {
    var d = cents / 100;
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  }

  // Build Shopify CDN sized image URL
  function sizedImg(src, size) {
    if (!src) return '';
    // Insert _<size> before the file extension, after stripping any existing size suffix
    return src
      .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|\d+x\d*|\d*x\d+)(crop_\w+)?(?=\.)/, '')
      .replace(/(\.\w{2,4})(\?|$)/, '_' + size + '$1$2');
  }

  function buildCartHTML(cart) {
    if (cart.item_count === 0) {
      return '<p class="cart-drawer__empty">Your cart is empty.</p>';
    }

    var html = '<ul class="cart-drawer__items">';
    cart.items.forEach(function (item) {
      var img = item.image ? sizedImg(item.image, '160x160') : '';
      var title = (item.product_title || '').replace(/&/g, '&amp;').replace(/</g, '&lt;');
      html += '<li class="cart-drawer__item">';
      html += '  <a href="' + item.url + '">';
      if (img) html += '    <img src="' + img + '" alt="' + title + '" width="80" height="80" loading="lazy">';
      html += '  </a>';
      html += '  <div class="cart-drawer__item-info">';
      html += '    <a href="' + item.url + '" class="cart-drawer__item-title">' + title + '</a>';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        html += '    <p class="cart-drawer__item-variant">' + item.variant_title + '</p>';
      }
      if (item.selling_plan_allocation) {
        html += '    <p class="cart-drawer__item-variant">' + item.selling_plan_allocation.selling_plan.name + '</p>';
      }
      html += '    <p class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>';
      html += '    <div class="cart-drawer__qty">';
      html += '      <button class="qty-btn" data-action="decrease" data-key="' + item.key + '" aria-label="Decrease quantity">−</button>';
      html += '      <span class="qty-val">' + item.quantity + '</span>';
      html += '      <button class="qty-btn" data-action="increase" data-key="' + item.key + '" aria-label="Increase quantity">+</button>';
      html += '    </div>';
      html += '  </div>';
      html += '  <button class="cart-drawer__remove" data-key="' + item.key + '" aria-label="Remove item">';
      html += '    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
      html += '  </button>';
      html += '</li>';
    });
    html += '</ul>';
    return html;
  }

  function refreshCartDrawer(callback) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Badge counts
        document.querySelectorAll('.gh__cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          cart.item_count > 0 ? el.removeAttribute('hidden') : el.setAttribute('hidden', '');
        });

        // Subtotal
        var sub = document.getElementById('cart-subtotal');
        if (sub) sub.textContent = formatMoney(cart.total_price);

        // Drawer body
        var body = document.getElementById('cart-drawer-body');
        if (body) body.innerHTML = buildCartHTML(cart);

        if (typeof callback === 'function') callback();
      })
      .catch(function (err) {
        console.error('[Cart] refresh failed:', err);
      });
  }

  // ── Cart item interactions via EVENT DELEGATION ────────────
  // One permanent listener on the body handles all qty/remove
  // clicks even after the HTML is rebuilt.
  var cartBody = document.getElementById('cart-drawer-body');
  if (cartBody) {
    cartBody.addEventListener('click', function (e) {
      // --- Qty button ---
      var qtyBtn = e.target.closest('.qty-btn');
      if (qtyBtn) {
        e.preventDefault();
        var key     = qtyBtn.getAttribute('data-key');
        var action  = qtyBtn.getAttribute('data-action');
        var qtyEl   = qtyBtn.closest('.cart-drawer__qty').querySelector('.qty-val');
        var current = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
        var newQty  = action === 'increase' ? current + 1 : Math.max(0, current - 1);

        // Optimistic UI update
        if (qtyEl) qtyEl.textContent = newQty;
        qtyBtn.disabled = true;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        })
          .then(function (r) { return r.json(); })
          .then(function () { refreshCartDrawer(); })
          .catch(function (err) {
            console.error('[Cart] qty update failed:', err);
            refreshCartDrawer(); // revert to real server state
          });
        return;
      }

      // --- Remove button ---
      var removeBtn = e.target.closest('.cart-drawer__remove');
      if (removeBtn) {
        e.preventDefault();
        var key = removeBtn.getAttribute('data-key');
        // Fade out the item immediately
        var item = removeBtn.closest('.cart-drawer__item');
        if (item) item.style.opacity = '0.4';

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
          .then(function (r) { return r.json(); })
          .then(function () { refreshCartDrawer(); })
          .catch(function (err) {
            console.error('[Cart] remove failed:', err);
            refreshCartDrawer();
          });
      }
    });
  }

  // ── AJAX Add to Cart ───────────────────────────────────────
  // The product form uses id="product-form".
  // ReCharge's subscription widget (rendered inside the form via
  // content_for 'blocks') injects a selling_plan input which
  // FormData captures automatically.
  var productForm = document.getElementById('product-form');
  if (!productForm) {
    // Fallback selector in case ID is missing
    productForm = document.querySelector('form[action^="/cart/add"]');
  }

  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var atcBtn = productForm.querySelector('[type="submit"]');
      if (atcBtn) {
        atcBtn.setAttribute('disabled', '');
        atcBtn.textContent = 'Adding…';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(productForm)
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (d) {
              throw new Error(d.description || 'Could not add to cart');
            });
          }
          return r.json();
        })
        .then(function () {
          if (atcBtn) {
            atcBtn.removeAttribute('disabled');
            atcBtn.textContent = 'Add to Cart';
          }
          refreshCartDrawer(openCart);
        })
        .catch(function (err) {
          console.error('[Cart] add failed:', err);
          if (atcBtn) {
            atcBtn.removeAttribute('disabled');
            atcBtn.textContent = 'Add to Cart';
          }
          // Fall back to native submit so ReCharge or Shopify can handle it
          productForm.submit();
        });
    });
  }

});
